<template>
  <BlogPageLayout path="legal" />
</template>
